import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Wizard from 'components/organisms/Wizards/Wizard/Wizard';

const StyledSaveSearchWizard = styled(Wizard)`
  .Wizard {
    &-content {
      padding: 0;
    }
    &-step {
      &-content {
        padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(3)};

        .FormField {
          row-gap: ${props => props.theme.layout('0.5sp')};

          .FormLabel, .InputLabel {
            ${props => props.theme.font2Css('body2')};
            transform: scale(1);
          }
        }
      }
    }
  }

  ${props => props.theme.breakpoints.down('lg')} {
    .Wizard {
      &-step {
        &-content {
          padding: ${props => props.theme.spacing(2)};
        }
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledSaveSearchWizard.propTypes = {
  theme: PropTypes.object
};

export default StyledSaveSearchWizard;
